import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=96cfa7ce&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"
import style0 from "./exchange.vue?vue&type=style&index=0&id=96cfa7ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cfa7ce",
  null
  
)

export default component.exports